<agpr-take-over-panel
    #takeOverPanel
    id="editTopicTakeOverPanel"
    class="agpr-editTopicTakeoverPanel"
    [header]="panelTitle"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [validateBeforeClose]="exitValidation$"
    [responsiveWidth]="true"
    [minPanelWidth]="960"
    [maxPanelWidth]="1400"
    [showFooter]="false"
    [noScroll]="true"
    [noPadding]="true"
    [fullHeight]="true"
    (visibleChange)="onVisibleChange($event)"
>
    <ng-template #noScrollContent>
        <div class="agpr-editTopicTakeoverPanel-body">
            <agpr-monitoring-search
                [panelMode]="true"
                (searchRequested)="onSearchRequested()"
                (cancelRequested)="requestClose()"
            ></agpr-monitoring-search>
        </div>
    </ng-template>
</agpr-take-over-panel>
